import React, { useEffect } from "react";
import {
  PageFooterV2,
  RosterFeedbackModal,
  useWorkflowFeedback,
  Website,
} from "@amzn/squad-front-end-shared-react-components";
import { useDispatch, useSelector } from "react-redux";
import styles from "./footer.module.css";
import { buildLinkItems } from "./Footer-links";
import bannerSlice from "../../banner/bannerSlice";
import { RootState } from "../../redux/rootReducer";
import UserInfo from "../../user/UserInfo";
import { actions } from "../../user";

const Footer: React.FC = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(actions.getMeFetch());
  }, [dispatch]);

  const userAlias = useSelector(
    ({ user }: RootState) => (user.user as UserInfo)?.alias
  );
  const { visible, openFeedback, closeFeedback } = useWorkflowFeedback();

  return (
    <div className={styles["footer"]}>
      <PageFooterV2 linkItems={buildLinkItems(openFeedback)} />
      <RosterFeedbackModal
        visible={visible}
        onDismiss={closeFeedback}
        website={Website.CREW}
        userAlias={userAlias}
        onSubmit={() =>
          dispatch(
            bannerSlice.actions.setBanner({
              type: "success",
              content: "Your feedback has been submitted successfully.",
              dissmissible: true,
            })
          )
        }
      />
    </div>
  );
};

export default Footer;
